import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #TEXTAREA-FIELD
\*------------------------------------ */
/**
 * Textarea field label
 */
.cat-c-textarea-field__label {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  color: var(--cat-theme-color-content-default);
  padding-block-end: var(--cat-space-3x-small);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  font-weight: var(--cat-font-weight-semibold);
  word-wrap: break-word;
  max-width: 100%;
  position: relative;
  /**
   * Label color on disabled state
   */
  /**
   * Pointer events none on readonly state
   */
  /**
  * Hide label
  */
}
.cat-c-textarea-field__label .cat-c-textarea-field__label-inner-wrapper {
  max-width: 100%;
}
.cat-c-textarea-field--large .cat-c-textarea-field__label .cat-c-textarea-field__label-inner-wrapper {
  position: absolute;
  display: flex;
}
.cat-c-textarea-field--medium .cat-c-textarea-field__label .cat-c-textarea-field__label-inner-wrapper {
  max-width: 100%;
  display: inline-flex;
  word-wrap: break-word;
}
.cat-c-textarea-field--large .cat-c-textarea-field__label {
  height: calc(var(--size-base-unit) * 2);
  width: 100%;
}
.cat-c-textarea-field--medium .cat-c-textarea-field__label {
  max-width: 100%;
  width: 100%;
  display: inline-block;
  word-wrap: break-word;
}
.cat-is-disabled .cat-c-textarea-field__label {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}
.cat-is-readonly .cat-c-textarea-field__label {
  pointer-events: none;
}
.cat-c-textarea-field--medium .cat-c-textarea-field__label {
  padding: 0;
}
.cat-c-textarea-field--hidden-label .cat-c-textarea-field__label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.cat-c-textarea-field--large .cat-c-textarea-field--label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.cat-c-textarea-field__header {
  display: flex;
  gap: var(--cat-space-x-small);
  padding-inline: var(--cat-space-medium);
  padding-block: var(--cat-space-2x-small) var(--cat-space-3x-small);
}
.cat-c-textarea-field--medium .cat-c-textarea-field__header {
  padding-inline: 0;
  padding-block: 0 var(--cat-space-x-small);
}

/**
 * Disabled cursor when the textarea is disabled
 */
.cat-is-disabled .cat-c-text-area--container,
.cat-is-disabled .cat-c-textarea-field__field-note {
  cursor: not-allowed;
}

/**
 * Textarea field input
 */
.cat-c-textarea-field__input {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  display: -webkit-box;
  line-height: var(--cat-line-height-default, var(--cat-line-height-24));
  font-size: var(--cat-font-size-default, var(--cat-font-size-16));
  -webkit-box-orient: vertical;
  flex: 1;
  color: var(--cat-theme-color-content-default);
  text-overflow: ellipsis;
  border: none;
  margin: 0;
  padding: 0;
  padding-inline: var(--cat-space-medium);
  padding-block-end: calc(var(--size-base-unit) * 0.75);
  width: 100%;
  background: transparent;
  overflow: auto;
  /**
   * If the textarea is focused
   */
  /**
   * Disabled textarea resizing
   */
  /**
  * Padding of textarea for Error Warning icon
  */
}
.cat-c-textarea-field--medium .cat-c-textarea-field__input {
  padding-block-start: var(--cat-space-x-small);
  padding-inline-start: calc(var(--size-base-unit) * 1.5);
}
.cat-c-textarea-field__input:focus {
  outline: none;
}
.cat-c-textarea-field__input:hover:not(:focus, :focus-within, :disabled) {
  background: var(--component-form-form-background-hover);
}
.cat-c-textarea-field__input:disabled {
  background-color: var(--cat-theme-color-background-default-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}
.cat-c-textarea-field--auto .cat-c-textarea-field__input {
  overflow: hidden;
  resize: none;
}
.cat-c-textarea-field__input::placeholder {
  color: var(--cat-theme-color-content-subtle);
  font-size: var(--cat-font-size-16);
  line-height: var(--cat-line-height-24);
}
.cat-c-textarea-field__input:focus:not(:disabled, :read-only)::placeholder {
  color: transparent;
}
.cat-is-error .cat-c-textarea-field__input:focus:not(:disabled, :read-only)::placeholder {
  color: transparent;
}
.cat-c-textarea-field--no-resize .cat-c-textarea-field__input {
  resize: none;
}
.cat-is-error .cat-c-textarea-field__input, .cat-is-warning .cat-c-textarea-field__input, .cat-has-icon--after .cat-c-textarea-field__input {
  padding-inline-end: var(--cat-space-3x-large);
}

/**
* Style for Error Warning icon
*/
.cat-c-text-area__error-icon,
.cat-c-text-area__warning-icon,
::slotted(.cat-icon[slot=after]) {
  position: absolute;
  inset-inline-end: var(--cat-space-medium);
  inset-block-start: var(--cat-space-3x-small);
  pointer-events: none;
}

/**
* Style for field icon if Error or Warning icon is present
*/
.cat-has-icon--after .cat-c-text-area__error-icon,
.cat-has-icon--after .cat-c-text-area__warning-icon {
  inset-inline-end: var(--cat-space-3x-large);
}

/**
* Padding for input if field icon is present
*/
.cat-has-icon--after:is(.cat-is-error, .cat-is-warning) .cat-c-textarea-field__input {
  padding-inline-end: var(--cat-space-6x-large);
}

/**
 * Textarea (and other optional elements) wrapper
 */
.cat-c-textarea-field__body {
  position: relative;
  width: 100%;
  align-self: stretch;
  border-radius: calc(var(--size-base-unit) * 0.5);
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-form-border);
  display: flex;
  flex-direction: column;
  background-color: var(--cat-theme-color-background-default);
  /**
   * Styling for readonly state
   */
  /**
  * Style for Error variant when it is readonly state
  */
  /**
  * Style for Error Warning icon
  */
  /**
  * Style for field icon if Error or Warning icon is present
  */
}
:not(.cat-is-disabled).cat-is-error .cat-c-textarea-field__body {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-utility-error);
}
.cat-c-textarea-field__body:hover:not(:disabled, :active) {
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-form-border-hover);
  background: var(--cat-theme-color-form-background-hover);
}
.cat-is-error .cat-c-textarea-field__body:hover:not(:disabled, :active) {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-utility-error);
}
.cat-c-textarea-field__body:focus-within {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-textarea-field__body .cat-c-textarea-wrapper {
  display: flex;
  gap: var(--cat-space-x-small);
  position: relative;
}
.cat-is-disabled .cat-c-textarea-field__body {
  background-color: var(--cat-theme-color-background-default-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-disabled .cat-c-textarea-field__body .cat-c-textarea-field__input::placeholder {
  color: var(--cat-theme-color-content-disabled);
}
.cat-is-disabled .cat-c-textarea-field__body:hover, .cat-is-disabled .cat-c-textarea-field__body:hover:active, .cat-is-disabled .cat-c-textarea-field__body:active {
  background-color: var(--cat-theme-color-background-default-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-content-disabled);
  outline: none;
}
.cat-is-readonly .cat-c-textarea-field__body {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-readonly);
  border-width: var(--cat-theme-border-width);
}
.cat-is-readonly .cat-c-textarea-field__body:hover, .cat-is-readonly .cat-c-textarea-field__body:active, .cat-is-readonly .cat-c-textarea-field__body:not(.cat-textarea-body__focus, .cat-textarea-body__active):focus-within {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-background-default-disabled);
  border-width: var(--cat-theme-border-width);
  background: none;
}
.cat-is-readonly .cat-c-textarea-field__body:active, .cat-is-readonly .cat-c-textarea-field__body:not(.cat-textarea-body__focus, .cat-textarea-body__active) {
  outline: none;
}
.cat-is-readonly .cat-c-textarea-field__body .cat-c-textarea-field__input {
  cursor: default;
}
.cat-is-readonly .cat-c-textarea-field__body .cat-c-textarea-field__input::placeholder {
  color: var(--cat-theme-color-content-default);
}
.cat-is-readonly .cat-c-textarea-field__body .cat-c-textarea-field__input:hover {
  background: none;
}
.cat-is-error.cat-is-readonly .cat-c-textarea-field__body:hover, .cat-is-error.cat-is-readonly .cat-c-textarea-field__body:active, .cat-is-error.cat-is-readonly .cat-c-textarea-field__body:focus-within {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-utility-error);
}
.cat-c-textarea-field__body .cat-c-text-area__error-icon,
.cat-c-textarea-field__body .cat-c-text-area__warning-icon,
.cat-c-textarea-field__body ::slotted(.cat-icon[slot=after]) {
  pointer-events: none;
}
.cat-c-textarea-field__body .cat-has-icon--after .cat-c-text-area__error-icon,
.cat-c-textarea-field__body .cat-has-icon--after .cat-c-text-area__warning-icon {
  inset-inline-end: var(--cat-space-3x-large);
}

/**
* Textarea field  maxlength 
*/
slot[name=word-count] .cat-c-text-field__maxlength {
  display: flex;
  align-items: flex-end;
  inset-inline-end: 0;
  font-size: var(--cat-font-size-12);
  font-weight: var(--cat-font-weight-regular);
  line-height: var(--cat-line-height-16);
}
.cat-is-disabled slot[name=word-count] .cat-c-text-field__maxlength {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}

/**
* Field Note color 
*/
.cat-c-field-note slot[name=field-note] {
  color: var(--cat-theme-color-content-default);
}

/**
* Textarea field  field note in the footer
*/
.cat-c-textarea-field__field-note {
  flex-basis: 100%;
}

/**
 * Color for required-text for required fields
 */
.cat-c-textarea-field__required-text {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  color: var(--cat-theme-color-content-subtle);
  margin-inline-start: var(--cat-space-3x-small);
}
.cat-c-textarea-field--large .cat-c-textarea-field__required-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow: var(--cat-c-textarea-field-notation-overflow, visible);
  max-width: 50%;
}
.cat-is-disabled .cat-c-textarea-field__required-text {
  color: var(--cat-theme-color-content-disabled);
}

/**
 * Apply gap between loaders 
 */
.cat-c-text-area--loader {
  display: flex;
  flex-direction: column;
  gap: var(--cat-space-3x-small);
}

.cat-c-text-area__max-length-loader {
  margin-inline-start: auto;
}

.cat-c-text-area__label-container {
  display: flex;
  justify-content: space-between;
}

/**
 * Inputfield area height in dropdown loader with chevron arrow
 */
.cat-c-text-area__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 7.5);
  position: relative;
}

/**
  * Loader Skeleton styles
  */
.cat-c-text-area__md-label-loader {
  width: var(--cat-c-text-area__md-label-loader-width, calc(var(--size-base-unit) * 16));
  max-width: var(--cat-c-text-area__md-label-loader-max-width, calc(50% - var(--size-base-unit) * 1));
}

.cat-c-text-area__max-length-loader {
  width: var(--cat-c-text-area__max-length-loader-width, calc(var(--size-base-unit) * 8));
  max-width: var(--cat-c-text-area__max-length-loader-max-width, calc(50% - var(--size-base-unit) * 1));
}

.cat-c-text-area__fieldnote-loader {
  width: var(--cat-c-text-area__fieldnote-loader-width, calc(var(--size-base-unit) * 32));
  max-width: var(--cat-c-text-area__fieldnote-loader-max-width, 100%);
}
`;
       